/* eslint-disable max-len */

import React from 'react';

export const CheckmarkDoneOutlineIcon = () => {
  return (
    <svg
      className="stroke-icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33333 8.66667L4.66667 12L13.3333 3.33333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33333 8.66667L8.66667 12L14.6667 4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
